import React, { Component } from 'react'

//region Components

import { translate } from 'components/shared/internationalization'
import i18n from 'i18next'

//endregion

//region Redux

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from '../../../reducers/minuteEditorReducer'
import { actions as takerActions } from '../../../reducers/minuteTakerReducer'

import selectors from '../../../selectors/minuteEditorSelectors'
import UserChip from 'components/shared/UserChip'
import ThreeSectionAttendeeManager from 'components/shared/ThreeSectionAttendeeManager/ThreeSectionAttendeeManager'
import { ManWithTimeIcon } from 'assets/icons/ManWithTimeIcon'
import { LocationIcon } from 'assets/icons/LocationIcon'
import {
    LoaderOverlay,
    Spinner
} from 'components/shared/ThreeSectionAttendeeManager/attendeeStyledComponents'
import styled from '@emotion/styled'
import { transientStorageManager } from 'businesslayer/minutesSessionStore'
import { InputLabelStyled } from 'components/minutetaker/components/form/AssigneeChipInputField'
import { getMinutesDetail } from 'businesslayer/api/minutes'
import blockingOperation from 'businesslayer/blockingOperation'
import { saveMinutes } from 'businesslayer/networkrequests/minutes/minutes'
import { getSessionStorageItem } from 'businesslayer/minutesLocalStore'
import { ATTENDANCE_MODE, API_ATTENDEE_STATE_KEYS } from 'common/constants/constants'
import { MINUTES_EDIT_OPTIONS } from 'components/minutetaker/components/InvitationView/types'

//endregion

//region Props

type Props = {
    actions: {
        editMinuteItem: (...args: any[]) => void
        loadContacts: (...args: any[]) => void
        validateChanges: (...args: any[]) => void
        saveExistingMinuteItem: (...args: any[]) => void
    }
    takerActions?: {
        syncAttendeesLocalDataChanges: (...args: any[]) => void
        saveAttendeesPending: () => void
        saveAttendeesFulfilled: (payload: any) => void
        saveAttendeesRejected: () => void
    }
    editedItem: any
    linkedBook: any
    currentMinuteItem: any
    saveComplete: boolean
    readyToSave: boolean
    isSavingExisting: boolean
    saveAttendeesUponEdit: boolean
    hideAvatars: boolean
    hideFloatingLabel: boolean
    onAttendeesAdd: ((...args: any[]) => void) | null
    onAttendeesDelete: ((...args: any[]) => void) | null
    allContacts: Array<any> | null
    readonly?: boolean
    readonlyForCreate?: boolean
    apiAttendees?: any[]
    editMode?: string
    editModalInvitedAttendees?: any[]
    editModalPresentAttendees?: any[]
    editModalApologiesAttendees?: any[]
    onRegisterGetData?: (getter: () => any) => void
    minutesSections?: any[]
    isLoading?: boolean
}

type State = {
    presentMockDataInitialized: boolean
    absentMockDataInitialized: boolean
    apiInvitedAttendees: any[]
    apiPresentAttendees: any[]
    apiAbsentAttendees: any[]
}

//endregion

//region Implementation
/**
 * This Component needs MAJOR refactoring. It should simply take
 * a list of attendeees and a callback to add/delete instead of
 * using redux internally. This has confusing logic in order
 * to be "reused" on the taker.
 */
class MinuteManagerAttendees extends Component<Props, State> {
    private saveAttendeesTimeout: any = null
    private isSavingInProgress: boolean = false
    private isLoadingAttendees: boolean = false
    private hideLoaderTimeout: any = null

    state: State = {
        presentMockDataInitialized: false,
        absentMockDataInitialized: false,
        apiInvitedAttendees: [],
        apiPresentAttendees: [],
        apiAbsentAttendees: []
    }

    loadMinuteItem = (item) => {
        if (!this.props.editedItem || +item.id !== +this.props.editedItem.id) {
            // reset minutesItem
            transientStorageManager.selectedMinuteItem = undefined
            this.props.actions.editMinuteItem(item)
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        let needsReinitialization = false

        if (nextProps.saveAttendeesUponEdit) {
            const currentId = this.props.currentMinuteItem?.id || this.props.editedItem?.id
            const nextId = nextProps.currentMinuteItem?.id || nextProps.editedItem?.id

            if (nextId && String(currentId) !== String(nextId)) {
                this.fetchAttendeesData(nextId)
            }
        }

        //If currentMinuteItem property provided it means we use this control externally,
        //from taker. Then we need to nmake sure reducer is initialized properly.
        if (
            nextProps.currentMinuteItem &&
            nextProps.currentMinuteItem !== this.props.currentMinuteItem
        ) {
            this.loadMinuteItem(nextProps.currentMinuteItem)
            needsReinitialization = true
        }

        const currentAttendeesIds = (this.props.apiAttendees || [])
            .map((a) => a.id || a.external_id)
            .join(',')
        const nextAttendeesIds = (nextProps.apiAttendees || [])
            .map((a) => a.id || a.external_id)
            .join(',')

        if (currentAttendeesIds !== nextAttendeesIds) {
            needsReinitialization = true
        }

        if (
            (nextProps.editMode === MINUTES_EDIT_OPTIONS.EDIT ||
                nextProps.editMode === MINUTES_EDIT_OPTIONS.DUPLICATE) &&
            (nextProps.editModalInvitedAttendees ||
                nextProps.editModalPresentAttendees ||
                nextProps.editModalApologiesAttendees) &&
            (nextProps.editModalInvitedAttendees !== this.props.editModalInvitedAttendees ||
                nextProps.editModalPresentAttendees !== this.props.editModalPresentAttendees ||
                nextProps.editModalApologiesAttendees !== this.props.editModalApologiesAttendees)
        ) {
            this.setState({
                apiInvitedAttendees: nextProps.editModalInvitedAttendees
                    ? this.mapAttendeeData(nextProps.editModalInvitedAttendees)
                    : [],
                apiPresentAttendees: nextProps.editModalPresentAttendees
                    ? this.mapAttendeeData(nextProps.editModalPresentAttendees)
                    : [],
                apiAbsentAttendees: nextProps.editModalApologiesAttendees
                    ? this.mapAttendeeData(nextProps.editModalApologiesAttendees)
                    : []
            })
        }

        if (needsReinitialization) {
            this.setState(
                {
                    presentMockDataInitialized: false,
                    absentMockDataInitialized: false
                },
                () => {
                    setTimeout(() => {
                        this.initializeAttendeesState()
                    }, 0)
                }
            )
        }

        //
        if (!this.props.saveComplete && nextProps.saveComplete) {
            //When we complete saving we would want to get item refreshed in the reducer
            //Technically this case is only applicable when this editor component is reused
            //externally, so consumers of this component could get a hold of fresh object
            //after it was saved.
            //console.log('Refreshing attendee editor with new fresh data')
            this.props.actions.editMinuteItem()
        }
    }

    async componentDidMount() {
        if (this.props.onRegisterGetData) {
            this.props.onRegisterGetData(this.getAttendeesData)
        }

        const { editedItem, currentMinuteItem } = this.props

        if (!editedItem && currentMinuteItem) {
            this.loadMinuteItem(currentMinuteItem)
        } else {
            this.props.actions.editMinuteItem(currentMinuteItem)
        }

        if (editedItem && editedItem.attendees) {
            editedItem.attendees.forEach((c) => (c.isInverted = false))
        }

        this.props.actions.loadContacts(true)
        setTimeout(() => {
            this.initializeAttendeesState()
        }, 0)

        const {
            editMode,
            saveAttendeesUponEdit,
            editModalInvitedAttendees,
            editModalPresentAttendees,
            editModalApologiesAttendees
        } = this.props

        if (
            (editMode === MINUTES_EDIT_OPTIONS.EDIT ||
                editMode === MINUTES_EDIT_OPTIONS.DUPLICATE) &&
            (editModalInvitedAttendees || editModalPresentAttendees || editModalApologiesAttendees)
        ) {
            this.setState({
                apiInvitedAttendees: editModalInvitedAttendees
                    ? this.mapAttendeeData(editModalInvitedAttendees)
                    : [],
                apiPresentAttendees: editModalPresentAttendees
                    ? this.mapAttendeeData(editModalPresentAttendees)
                    : [],
                apiAbsentAttendees: editModalApologiesAttendees
                    ? this.mapAttendeeData(editModalApologiesAttendees)
                    : []
            })
        } else if (saveAttendeesUponEdit) {
            const minuteId = currentMinuteItem?.id || editedItem?.id
            if (minuteId) {
                blockingOperation.showProgress(null)
                await this.fetchAttendeesData(minuteId)
            }
        } else if (editMode === MINUTES_EDIT_OPTIONS.CREATE) {
            if (this.props.apiAttendees && this.props.apiAttendees.length > 0) {
                const mappedAttendees = this.props.apiAttendees.map((attendee: any) => ({
                    id: attendee.id,
                    name: attendee.display_name || attendee.name,
                    email: attendee.email,
                    text: attendee.display_name || attendee.name,
                    value: attendee.display_name || attendee.name,
                    isLocationRemote: false,
                    isTimeLate: false
                }))

                this.setState({
                    apiPresentAttendees: mappedAttendees
                })
            } else {
                const currentUser = transientStorageManager.currentUser
                if (currentUser) {
                    const currentUserData = {
                        id: currentUser.id,
                        name: currentUser.display_name,
                        email: currentUser.email,
                        text: currentUser.display_name,
                        value: currentUser.display_name
                    }

                    this.setState(
                        {
                            apiPresentAttendees: [currentUserData]
                        },
                        () => {
                            if (this.props.saveAttendeesUponEdit && this.props.takerActions) {
                                this.props.takerActions.syncAttendeesLocalDataChanges({
                                    presentAttendees: this.state.apiPresentAttendees,
                                    invitedAttendees: this.state.apiInvitedAttendees,
                                    absentAttendees: this.state.apiAbsentAttendees
                                })
                            }
                        }
                    )
                }
            }
        }
    }

    componentWillUnmount() {
        if (this.saveAttendeesTimeout) {
            clearTimeout(this.saveAttendeesTimeout)
        }
        this.isSavingInProgress = false
    }

    private async fetchAttendeesData(documentId: string | number) {
        blockingOperation.showProgress(null)
        this.isLoadingAttendees = true
        this.forceUpdate()

        try {
            const minutesDetails = await getMinutesDetail(String(documentId), null, true)
            const minutesData = minutesDetails.minutesDocuments?.[documentId]?.attributes

            this.hideLoaderTimeout = setTimeout(() => {
                blockingOperation.hideProgress(null)
            }, 1000)

            this.setState(
                {
                    apiInvitedAttendees: minutesData?.attending
                        ? this.mapAttendeeData(minutesData.attending)
                        : [],
                    apiPresentAttendees: minutesData?.present
                        ? this.mapAttendeeData(minutesData.present)
                        : [],
                    apiAbsentAttendees: minutesData?.apologies
                        ? this.mapAttendeeData(minutesData.apologies)
                        : []
                },
                () => {
                    if (this.props.takerActions) {
                        this.props.takerActions.syncAttendeesLocalDataChanges({
                            presentAttendees: this.state.apiPresentAttendees,
                            invitedAttendees: this.state.apiInvitedAttendees,
                            absentAttendees: this.state.apiAbsentAttendees
                        })
                    }
                    this.isLoadingAttendees = false
                    this.forceUpdate()
                }
            )
        } catch (error) {
            console.error('Error fetching attendees data:', error)
            this.isLoadingAttendees = false
            this.forceUpdate()
            if (this.hideLoaderTimeout) {
                clearTimeout(this.hideLoaderTimeout)
                this.hideLoaderTimeout = null
            }
            blockingOperation.hideProgress(null, error)
        }
    }

    public getAttendeesData = () => {
        return {
            presentAttendees: this.state.apiPresentAttendees,
            invitedAttendees: this.state.apiInvitedAttendees,
            absentAttendees: this.state.apiAbsentAttendees
        }
    }

    private mapAttendeeData = (attendees: any[]) => {
        return attendees.map((attendee) => ({
            id: attendee.id,
            external_id: attendee.external_id,
            name: attendee.display_name,
            email: attendee.email,
            text: attendee.display_name,
            value: attendee.display_name,
            isLocationRemote: attendee.attendance_mode === ATTENDANCE_MODE.REMOTE,
            isTimeLate: attendee.partial_attendance === true
        }))
    }

    private createAttendeeChangeHandler = (
        stateKey:
            | typeof API_ATTENDEE_STATE_KEYS.INVITED
            | typeof API_ATTENDEE_STATE_KEYS.PRESENT
            | typeof API_ATTENDEE_STATE_KEYS.ABSENT
    ) => {
        return (attendees: any[]) => {
            this.setState({ [stateKey]: attendees } as any, () => {
                if (this.props.saveAttendeesUponEdit && this.props.takerActions) {
                    this.props.takerActions.syncAttendeesLocalDataChanges({
                        presentAttendees: this.state.apiPresentAttendees,
                        invitedAttendees: this.state.apiInvitedAttendees,
                        absentAttendees: this.state.apiAbsentAttendees
                    })
                }

                this.debouncedApiCall()
            })
        }
    }

    private debouncedApiCall = () => {
        if (!this.props.saveAttendeesUponEdit || !this.props.takerActions) {
            return
        }

        if (this.saveAttendeesTimeout) {
            clearTimeout(this.saveAttendeesTimeout)
        }

        this.saveAttendeesTimeout = setTimeout(() => {
            this.saveAttendeesToApi()
        }, 1500)
    }

    private saveAttendeesToApi = async () => {
        if (this.isSavingInProgress) {
            this.debouncedApiCall()
            return
        }

        const { editedItem, currentMinuteItem, minutesSections } = this.props
        const minutesItem = editedItem || currentMinuteItem

        if (!minutesItem || !this.props.takerActions) {
            return
        }

        const currentCommitteeId = getSessionStorageItem('currentCommitteeId')
        if (!currentCommitteeId) {
            console.error('Committee ID not found')
            return
        }

        let attendanceNotes = ''
        if (minutesSections && minutesSections.length > 0) {
            const attendeesSection = minutesSections.find((s) => s.sectionType === 'attendees')
            if (attendeesSection && attendeesSection.body) {
                attendanceNotes = attendeesSection.body
            }
        }

        const itemToSave = {
            ...minutesItem,
            id: minutesItem.id,
            title: minutesItem.attributes?.title || minutesItem.title || '',
            location: minutesItem.attributes?.location || minutesItem.location || '',
            includeLogo: minutesItem.attributes?.include_logo,
            includeBookStructure: minutesItem.attributes?.include_book_structure,
            includeSubTabs: minutesItem.attributes?.include_sub_tabs,
            presentAttendees: this.state.apiPresentAttendees,
            invitedAttendees: this.state.apiInvitedAttendees,
            absentAttendees: this.state.apiAbsentAttendees,
            notes: attendanceNotes
        }

        try {
            this.isSavingInProgress = true

            this.props.takerActions.saveAttendeesPending()

            const response: any = await saveMinutes(currentCommitteeId, itemToSave)

            const updatedAt =
                response?.minutesDocuments?.[itemToSave.id]?.attributes?.updatedAt ||
                response?.data?.attributes?.updated_at ||
                new Date().toISOString()

            this.props.takerActions.saveAttendeesFulfilled({ updatedAt })
        } catch (error) {
            console.error('Error saving attendees:', error)
            this.props.takerActions.saveAttendeesRejected()
        } finally {
            this.isSavingInProgress = false
        }
    }

    private initializeAttendeesState = () => {
        const { presentMockDataInitialized, absentMockDataInitialized } = this.state
        if (presentMockDataInitialized && absentMockDataInitialized) {
            return
        }

        this.setState({
            presentMockDataInitialized: true,
            absentMockDataInitialized: true
        })
    }

    private renderAttendeesDataSourceForThreeSections = (
        section1Data: any[],
        section2Data: any[],
        section3Data: any[]
    ) => {
        const { allContacts } = this.props

        if (!allContacts) {
            return []
        }

        const combinedSectionData = [...section1Data, ...section2Data, ...section3Data]

        const keys = Object.keys(allContacts)
        const filtered = keys.filter((key) => {
            const existsInCombinedSections = combinedSectionData.find((existing) => {
                return (
                    `${existing.id}` === key ||
                    existing.text === allContacts[key].attributes.displayName ||
                    existing.name === allContacts[key].attributes.displayName
                )
            })
            return !existsInCombinedSections
        })

        return filtered.map((key) => {
            const item = allContacts[key]
            return {
                text: item.attributes.displayName,
                email: item.attributes.email,
                id: item.id,
                external_id: item.external_id,
                value: item.attributes.displayName
            }
        })
    }

    private processAttendeesData = (attendees: any[]) => {
        // Common function to process attendees data with isInverted logic
        if (!attendees || attendees.length === 0) {
            return []
        }

        // We are returning new modified array in here because we need to modify data just in time
        // That modification is pertaining to flip of email / display name
        // This array is only used by control so original array stays unchanged.
        // This way we preserve original display name value
        return [
            ...attendees.map((c) => {
                if (c.isInverted) {
                    let newObject = Object.assign({}, c)

                    // If we change object's display name we have to make a copy so original would not be affected.
                    newObject.text = newObject.email
                        ? newObject.email
                        : translate('NO_EMAIL_PERSON_LABEL')
                    return newObject
                }
                return c
            })
        ]
    }

    private getInvitedAttendeesData = () => {
        return this.state.apiInvitedAttendees
    }

    private getPresentAttendeesData = () => {
        return this.state.apiPresentAttendees
    }

    private getAbsentAttendeesData = () => {
        return this.state.apiAbsentAttendees
    }

    private getInvitedAttendeesDataForUserChip = () => {
        return this.processAttendeesData(this.state.apiInvitedAttendees)
    }

    private getPresentAttendeesDataForUserChip = () => {
        return this.processAttendeesData(this.state.apiPresentAttendees)
    }

    private getAbsentAttendeesDataForUserChip = () => {
        return this.processAttendeesData(this.state.apiAbsentAttendees)
    }

    private getDataAnalyticsValue = (): string => {
        if (this.props.saveAttendeesUponEdit) {
            return 'TAKER'
        }
        if (
            this.props.editMode === MINUTES_EDIT_OPTIONS.CREATE &&
            this.props.apiAttendees &&
            this.props.apiAttendees.length > 0
        ) {
            return 'BOARDS'
        }
        if (
            this.props.editMode === MINUTES_EDIT_OPTIONS.CREATE ||
            this.props.editMode === MINUTES_EDIT_OPTIONS.EDIT ||
            this.props.editMode === MINUTES_EDIT_OPTIONS.DUPLICATE
        ) {
            return this.props.editMode.toUpperCase()
        }
        return 'BOARDS'
    }

    render() {
        const { editedItem, readonly } = this.props
        if (!editedItem) {
            return null
        }

        return (
            <>
                <div
                    data-testid="MinuteManagerModal_AttendeesChipInput"
                    id={'ChipInputFieldContainer'}
                    role="group"
                    aria-describedby="Invited_Attendees-chip-input">
                    {readonly ? (
                        <>
                            {/* Present Section */}
                            <InputLabelStyled
                                aria-label={i18n.t('ATTENDANCE_PRESENT')}
                                htmlFor="Present_Attendees">
                                {i18n.t('ATTENDANCE_PRESENT')}
                            </InputLabelStyled>
                            <ReadOnlyChipArea aria-live="polite">
                                {this.getPresentAttendeesDataForUserChip().map((attendee) => {
                                    return (
                                        <UserChip
                                            readonly
                                            key={attendee.id || `present-${attendee.text}`}
                                            name={attendee.text}
                                            email={attendee.email}
                                            {...(attendee.isTimeLate && {
                                                interactiveIcon: <ManWithTimeIcon />
                                            })}
                                            {...(attendee.isLocationRemote && {
                                                secondaryInteractiveIcon: <LocationIcon />
                                            })}
                                            isTimeLate={attendee.isTimeLate}
                                            isLocationRemote={attendee.isLocationRemote}
                                        />
                                    )
                                })}
                                {this.isLoadingAttendees && (
                                    <LoaderOverlay>
                                        <Spinner />
                                    </LoaderOverlay>
                                )}
                            </ReadOnlyChipArea>

                            {/* Attending/Invited Section */}
                            <InputLabelStyled
                                aria-label={i18n.t('INVITED_ATTENDEES')}
                                htmlFor="Invited_Attendees"
                                style={{ marginTop: '24px' }}>
                                {i18n.t('INVITED_ATTENDEES')}
                            </InputLabelStyled>
                            <ReadOnlyChipArea aria-live="polite">
                                {this.getInvitedAttendeesDataForUserChip().map((attendee) => {
                                    return (
                                        <UserChip
                                            readonly
                                            key={attendee.id || `invited-${attendee.text}`}
                                            name={attendee.text}
                                            email={attendee.email}
                                            {...(attendee.isTimeLate && {
                                                interactiveIcon: <ManWithTimeIcon />
                                            })}
                                            {...(attendee.isLocationRemote && {
                                                secondaryInteractiveIcon: <LocationIcon />
                                            })}
                                            isTimeLate={attendee.isTimeLate}
                                            isLocationRemote={attendee.isLocationRemote}
                                        />
                                    )
                                })}
                                {this.isLoadingAttendees && (
                                    <LoaderOverlay>
                                        <Spinner />
                                    </LoaderOverlay>
                                )}
                            </ReadOnlyChipArea>

                            {/* Apologies/Absent Section */}
                            <InputLabelStyled
                                aria-label={i18n.t('ATTENDANCE_ABSENT')}
                                htmlFor="Absent_Attendees"
                                style={{ marginTop: '24px' }}>
                                {i18n.t('ATTENDANCE_ABSENT')}
                            </InputLabelStyled>
                            <ReadOnlyChipArea aria-live="polite">
                                {this.getAbsentAttendeesDataForUserChip().map((attendee) => {
                                    return (
                                        <UserChip
                                            readonly
                                            hideIcons
                                            key={attendee.id || `absent-${attendee.text}`}
                                            name={attendee.text}
                                            email={attendee.email}
                                            {...(attendee.isTimeLate && {
                                                interactiveIcon: <ManWithTimeIcon />
                                            })}
                                            {...(attendee.isLocationRemote && {
                                                secondaryInteractiveIcon: <LocationIcon />
                                            })}
                                            isTimeLate={attendee.isTimeLate}
                                            isLocationRemote={attendee.isLocationRemote}
                                        />
                                    )
                                })}
                                {this.isLoadingAttendees && (
                                    <LoaderOverlay>
                                        <Spinner />
                                    </LoaderOverlay>
                                )}
                            </ReadOnlyChipArea>
                        </>
                    ) : (
                        <ThreeSectionAttendeeManager
                            invitedAttendees={this.getInvitedAttendeesData()}
                            presentAttendees={this.getPresentAttendeesData()}
                            absentAttendees={this.getAbsentAttendeesData()}
                            onInvitedAttendeesChange={this.createAttendeeChangeHandler(
                                API_ATTENDEE_STATE_KEYS.INVITED
                            )}
                            onPresentAttendeesChange={this.createAttendeeChangeHandler(
                                API_ATTENDEE_STATE_KEYS.PRESENT
                            )}
                            onAbsentAttendeesChange={this.createAttendeeChangeHandler(
                                API_ATTENDEE_STATE_KEYS.ABSENT
                            )}
                            searchOptions={this.renderAttendeesDataSourceForThreeSections(
                                this.getInvitedAttendeesData(),
                                this.getPresentAttendeesData(),
                                this.getAbsentAttendeesData()
                            ).map((option) => ({
                                ...option,
                                name: (option as any).name || option.text
                            }))}
                            allContacts={this.props.allContacts as any}
                            enableSearch={true}
                            readonlyForCreate={this.props.readonlyForCreate || false}
                            showLabels={true}
                            invitedLabel={i18n.t('INVITED_ATTENDEES')}
                            presentLabel={i18n.t('ATTENDANCE_PRESENT')}
                            absentLabel={i18n.t('ATTENDANCE_ABSENT')}
                            isLoading={
                                this.props.isLoading !== undefined
                                    ? this.props.isLoading
                                    : this.isLoadingAttendees
                            }
                            dataAnalytics={this.getDataAnalyticsValue()}
                        />
                    )}
                </div>
            </>
        )
    }
}

const ReadOnlyChipArea = styled('div')`
    border: 1px solid #949494;
    border-radius: 4px;
    padding: 0px 20px 0px 16px;
    margin-top: 6px;
    min-height: 90px;
    line-height: 20px;
    position: relative;
`

//endregion

//region Export / Redux Bindings

const mapStateToProps = (state, _) => {
    return {
        editedItem: selectors.editedItem(state.minuteEditorReducer),
        allContacts: selectors.allContacts(state.minuteEditorReducer),
        linkedBook: selectors.linkedBook(state.minuteEditorReducer),
        saveComplete: selectors.saveComplete(state.minuteEditorReducer),
        isSavingExisting: selectors.isSavingExisting(state.minuteEditorReducer),
        readyToSave: selectors.readyToSave(state.minuteEditorReducer)
    }
}

const mapDispatchToProps = (dispatch) => {
    const { editMinuteItem, loadContacts, validateChanges, saveExistingMinuteItem } = actions
    const {
        syncAttendeesLocalDataChanges,
        saveAttendeesPending,
        saveAttendeesFulfilled,
        saveAttendeesRejected
    } = takerActions
    return {
        actions: bindActionCreators(
            {
                editMinuteItem,
                loadContacts,
                validateChanges,
                saveExistingMinuteItem
            },
            dispatch
        ),
        takerActions: bindActionCreators(
            {
                syncAttendeesLocalDataChanges,
                saveAttendeesPending,
                saveAttendeesFulfilled,
                saveAttendeesRejected
            },
            dispatch
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MinuteManagerAttendees as any)

//endregion
